import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {ExternalHashList} from '../components/ExternalHashList';
import CreateHashContainer from './CreateHashContainer';
import Notification from '../components/structure/Notification';
import {NoInfo} from "../components/structure/NoInfo";

class ConfigContainer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showNotification: false,
      notification: {
        status: '',
        message: '',
        title: ''
      }
    };
    this.showNotification = this.showNotification.bind(this);
  }

  showNotification(type, message) {
    if (type === "success") {
      this.setState({
        showNotification: true,
        notification: {title: 'Success', message: message, status: 'success'}
      });
    } else {
      this.setState({
        showNotification: true,
        notification: {title: 'Error', message: message, status: 'danger'}
      });
    }
  }

  render() {

    const {externalHashList} = this.props;

    return (
      <div className="container">
        <div className="row mainBody">
            {externalHashList && externalHashList.length > 0 ? (
              <Fragment>
                {this.state.showNotification && <Notification notification={this.state.notification}/>}
                <ExternalHashList list={externalHashList}/>
                <CreateHashContainer showNotification={this.showNotification}/>
              </Fragment>

            ) : (<NoInfo displayMsg="There are no configurations available at this time"/>)}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {

  const {affiliates} = state;

  return {
    externalHashList: affiliates && affiliates.currentAffiliate.affiliateExternalHashList
  };

};

export default connect(mapStateToProps)(ConfigContainer);
